import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "facebook",
  "use": "facebook-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"facebook\"><path d=\"M14.885 12.43H12.36V19H9.788v-6.57H8v-2.364h1.788v-2.02C9.788 6.456 10.842 5 13.274 5c.985 0 1.713.093 1.713.093l-.057 2.206s-.742-.006-1.552-.006c-.878 0-1.018.393-1.018 1.045v1.728H15l-.115 2.364z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol